export enum AppEnvironments {
  internal = "internal",
  dev = "dev",
  devSix = "dev-six",
  stage = "stage",
  production = "production",
  uat = "uat",
  qa = "qa",
  api6uat = "api6uat",
}

export class Environment {
  static get currentEnvironment(): AppEnvironments {
    const currentEnv = process.env.VUE_APP_API_URL
      ? process.env.VUE_APP_API_URL
      : window.location.href;
    const normalizedEnv = currentEnv.toLowerCase();
    if (
      normalizedEnv.includes("profiles.traderverse.io") ||
      normalizedEnv.includes("app.traderverse.io") ||
      normalizedEnv.includes("app-api.traderverse.io")
    ) {
      return AppEnvironments.production;
    } else if (
      normalizedEnv.includes("profiletest-uat") ||
      normalizedEnv.includes("uat-app.traderverse.io")
    ) {
      return AppEnvironments.uat;
    } else if (normalizedEnv.includes("api-uat.traderverse.io")) {
      return AppEnvironments.api6uat;
    } else if (normalizedEnv.includes("qa-test")) {
      return AppEnvironments.qa;
    } else if (normalizedEnv.includes("dev-six")) {
      return AppEnvironments.devSix;
    } else if (
      normalizedEnv.includes("internal-profile") ||
      normalizedEnv.includes("social-internal") ||
      normalizedEnv.includes("74.208.95.190")
    ) {
      return AppEnvironments.internal;
    } else if (
      normalizedEnv.includes("profiles-stage") ||
      normalizedEnv.includes("social-stage") ||
      normalizedEnv.includes("74.208.115.53")
    ) {
      return AppEnvironments.stage;
    }
    return AppEnvironments.production;
  }

  static get domain(): string {
    if (
      window.location.href.toLowerCase().includes("profiles.traderverse.io")
    ) {
      return "profiles.traderverse.io";
    } else if (
      window.location.href.toLowerCase().includes("app.traderverse.io")
    ) {
      return "app.traderverse.io";
    } else if (
      window.location.href.toLowerCase().includes("app-api.traderverse.io")
    ) {
      return "app-api.traderverse.io";
    } else if (
      window.location.href.toLowerCase().includes("qa-test.traderverse.io")
    ) {
      return "qa-test.traderverse.io";
    } else if (
      window.location.href
        .toLowerCase()
        .includes("profiletest-uat.traderverse.io")
    ) {
      return "profiletest-uat.traderverse.io";
    } else if (
      window.location.href.toLowerCase().includes("uat-app.traderverse.io")
    ) {
      return "uat-app.traderverse.io";
    } else if (
      window.location.href.toLowerCase().includes("internal-profile") ||
      window.location.href.toLowerCase().includes("social-internal") ||
      window.location.host.toLowerCase().includes("74.208.95.190")
    ) {
      return "internal-profile.traderverse.io";
    } else if (
      window.location.href.toLowerCase().includes("profiles-stage") ||
      window.location.href.toLowerCase().includes("social-stage") ||
      window.location.host.toLowerCase().includes("74.208.115.53")
    ) {
      return "profiles-stage.traderverse.io";
    }
    return "profiles-develop.traderverse.io";
  }
}
